import React from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";

const RoomConfigList = (props) => {

   const columns = [
     { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
     { field: "ssid", headerName: "Ssid", flex: 1 },
     { field: "roomNo", headerName: "Room No", flex: 1 },
     { field: "roomType", headerName: "Room Type", flex: 1 }
     ];

    return (
        <div className="hotel-list">
            <p><b>Room Details</b></p>
            <TableWrapper
                data={[props?.fetchCDSNRoomConfigList]}
                columns={columns}
                noPagination={true}
            />
        </div>
    )
}

export default RoomConfigList;